export const trainBuyingEn = {
    shangpingxinxi:"Commodity information",
    peixunkechengxinxi:"Training course information",
    xianmaixianyong:"Buy now with now",
    dingdanheji:"Total order (including freight)",
    kechengjine:"Amount of course",
    yingfuzongjia:"To cope with the total price",
    payTitle:"Order transaction successful, watch the full video immediately!",
    guankankecheng:"Return to course details"
}


// WEBPACK FOOTER //
// ./src/lang/home/trainBuying/indexEn.js